import { render, staticRenderFns } from "./past_display_details.vue?vue&type=template&id=a9f8e21e&scoped=true&"
import script from "./past_display_details.vue?vue&type=script&lang=js&"
export * from "./past_display_details.vue?vue&type=script&lang=js&"
import style0 from "./past_display_details.vue?vue&type=style&index=0&id=a9f8e21e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8e21e",
  null
  
)

export default component.exports